import { connect, useDispatch } from 'react-redux';
import type { Dispatch } from 'redux';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router';

import { KnmErpStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErpStatusCodesEnum';
import { KnmTypeCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmTypeCodesEnum';
import { ExportFormatsEnum } from 'APIPackage/ImportExportModule/enums/ExportFormatsEnum';
import { IKnm } from 'APIPackage/KnmModule/interfaces/IKnm';
import {
  getIsPlanErknmStatusApproved,
  getIsPlanErknmStatusConsidered,
  getIsPlanErknmStatusInProcess,
  getIsPlanErknmStatusUnderConsideration,
} from 'APIPackage/PlanListModule/common/getPlanErknmStatusFlags';
import { ErknmPlanStatusesEnum } from 'APIPackage/PlanListModule/enums/ErknmPlanStatusesEnum';
import { ExportSimilaritiesListTypesEnum } from 'APIPackage/SimilarityModule/enums/ExportSimilaritiesListTypesEnum';
import {
  getUserProfileIsTest,
  getUserRoleIsAdmin,
  getUserRoleIsOmbudsman,
  getUserRoleIsProsecutorOrSuperProsecutor,
  getUserRoleIsSupervisor,
} from 'AuthPackage/MainModule/selectors/authSelectors';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import {
  knmAddVisibleModal,
  knmDeleteSign,
  knmDownloadCurrentVersion,
  knmDownloadSignedZip,
  knmDownloadXml,
  knmExcludeFromPlan,
  knmExportKnm,
  knmExportSimilaritiesList,
  knmRestore,
  knmRestoreToLatestVersion,
  knmSetActionsDropdownVisible,
} from 'KnmPackage/MainModule/actions/knmActions';
import { KnmModalsEnum } from 'KnmPackage/MainModule/enums/KnmModalsEnum';
import { KnmSystemTypesEnum } from 'KnmPackage/MainModule/enums/KnmSystemTypesEnum';
import {
  getIsKnmCanBeSigned,
  getKnmActionsDropdownVisible,
  getKnmData,
  getKnmDataCreated,
  getKnmDataResigningRequired,
  getKnmDownloadProsecutorDocs,
  getKnmErknmKnmKindDictionaryValue,
  getKnmErknmKnoOrganizationFormValue,
  getKnmErknmProfKindsSelectOptions,
  getKnmFormAgreementsValue,
  getKnmFormRef,
  getKnmIsChangePlanReasonActive,
  getKnmIsEditEnabledByEditors,
  getKnmIsErknmStatusAppealed,
  getKnmIsErknmStatusApproving,
  getKnmIsErknmStatusDecisionAppealed,
  getKnmIsErknmStatusFillInProcess,
  getKnmIsErknmStatusNotApprove,
  getKnmIsErknmStatusReadyForApprove,
  getKnmIsErknmStatusRemark,
  getKnmIsErknmStatusTypeCanceled,
  getKnmIsErknmStatusTypeCantBeCarryOut,
  getKnmIsErknmStatusTypeCarriedOut,
  getKnmIsErknmStatusTypeWaitingCarryOut,
  getKnmIsErpStatusClosedErknm,
  getKnmIsErpStatusDeleted,
  getKnmIsErpStatusNeedDoOverAgain,
  getKnmIsErpStatusNew,
  getKnmIsErpStatusSyspApprove,
  getKnmIsErpStatusTypeCarriedOut,
  getKnmIsErpStatusTypeWaitingCarryOut,
  getKnmIsTypeErknmPlanned,
  getKnmOpenChangeKnmModal,
  getKnmOpenRemoveFromPlanModal,
  getKnmSystemType,
} from 'KnmPackage/MainModule/selectors/knmSelectors';
import { planListExportPlanById } from 'PlanListPackage/MainModule/actions/planListActions';
import { getPlanListPlanErknmStatus } from 'PlanListPackage/MainModule/selectors/planListSelectors';
import { Dropdown } from 'UIPackage/MainModule/components/Dropdown';
import { DropdownItem } from 'UIPackage/MainModule/components/DropdownItem';
import { IDropdownItem } from 'UIPackage/MainModule/interfaces/IDropdownItem';
import { IKnmExclusionReasonSelectOption } from 'CorePackage/CatalogsModule/interfaces/IKnmExclusionReasonSelectOption';
import { IKnmMoveToPlanAttachment } from 'CorePackage/MainModule/interfaces/IKnmMoveToPlanAttachment';
import { getIsSticked } from 'CorePackage/HeaderModule/reducers/headerReducer';
import { isLaterThanAdminSetting } from 'CorePackage/MainModule/validators/isLaterThanAdminSetting';
import { AdminSettingCodesEnum } from 'APIPackage/AdminModule/enums/AdminSettingCodesEnum';
import { IAdminSetting } from 'APIPackage/AdminModule/interfaces/IAdminSetting';
import { getAdminFetchSettings } from 'PersonalAccountPackage/AdminModule/selectors/adminSelectors';
import { IKnmResultDecision248 } from 'APIPackage/KnmModule/interfaces/IKnmResultDecision248';
import { KindResultDecisionCodesEnum } from 'APIPackage/CatalogsModule/enums/KindResultDecisionCodesEnum';
import { KnmResultDecisionStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionStatusEnum';
import { IDictionarySelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionarySelectOption';
import { IProfKind } from 'APIPackage/DictionariesModule/interfaces/IProfKind';
import { IKnmAct248 } from 'APIPackage/KnmModule/interfaces/IKnmAct248';
import { ProfKindCodesEnum } from 'APIPackage/DictionariesModule/enums/ProfKindCodesEnum';
import { IPmResultDecision } from 'APIPackage/KnmModule/interfaces/IPmResultDecision';
import { IKnmSubject248 } from 'APIPackage/KnmModule/interfaces/IKnmSubject248';
import { KnmErknmStatusCodesEnum } from 'APIPackage/CatalogsModule/enums/KnmErknmStatusCodesEnum';
import { AgreementStatusEnum } from 'APIPackage/KnmModule/enums/AgreementStatusEnum';
import { IKnmFormRef } from 'KnmPackage/MainModule/interfaces/IKnmFormRef';
import { IKnmForm } from 'KnmPackage/MainModule/interfaces/IKnmForm';
import { IErknmFormAgreement } from 'KnmErknmPackage/MainModule/interfaces/IErknmFormAgreement';
import { KnmResultDecisionAgreementStatusEnum } from 'APIPackage/KnmModule/enums/KnmResultDecisionAgreementStatusEnum';
import { getKnmPmStatusHasHintFields, getKnmPmTypeFormValue } from 'KnmPmPackage/MainModule/selectors/knmPmSelectors';
import { ApprovedTypesEnum } from 'APIPackage/KnmModule/enums/ApprovedTypesEnum';
import { getLatestKnmErknmChangePlanReasonApproveType } from 'KnmErknmPackage/MainModule/selectors/knmErknmSelectors';
import { IDictionaryProfKindSelectOption } from 'CorePackage/DictionariesModule/interfaces/IDictionaryProfKindSelectOption';

import { defineIsActive } from '../common/defineIsActive';
import { ROUTE_FEEDBACK } from '../../../CorePackage/MainModule/routes/routes';
import { feedbackReset, feedbackSetKnmData } from '../../../FeedbackPackage/MainModule/actions/feedbackActions';
import { IFeedbackKnmData } from '../../../FeedbackPackage/MainModule/interfaces/IFeedbackKnmData';
import { IKnmKind } from '../../../APIPackage/DictionariesModule/interfaces/IKnmKind';
import { IDictionaryValue } from '../../../APIPackage/DictionariesModule/interfaces/IDictionaryValue';
import { ApproveRequiredTypesEnum } from '../../../APIPackage/KnmModule/enums/ApproveRequiredTypesEnum';
import { getAccountOrganizationsWithDistrictData } from '../../../CorePackage/AccountModule/selectors/accountSelectors';
import { IUserOrganisation } from '../../../APIPackage/AccountModule/interfaces/IUserOrganisation';
import { IDictionaryKnoOrganizationSelectOption } from '../../../CorePackage/DictionariesModule/interfaces/IDictionaryKnoOrganizationSelectOption';

interface IKnmHeaderDropdownProps {
  isOmbudsman: boolean | undefined;
  knmData: IKnm | undefined;
  isAdmin: boolean | undefined;
  isProsecutorOrSuperProsecutor: boolean | undefined;
  isSupervisor: boolean | undefined;
  knmSystemType: KnmSystemTypesEnum;
  knmPlanStatus: ErknmPlanStatusesEnum | undefined;
  isErknmStatusFillInProcess: boolean;
  isErknmStatusTypeCarriedOut: boolean;
  isErknmStatusTypeWaitingCarryOut: boolean;
  isErknmStatusTypeCantBeCarryOut: boolean;
  isErknmStatusApproving: boolean;
  isErknmStatusReadyForApprove: boolean;
  isErknmStatusNotApprove: boolean;
  isErknmStatusDecisionAppealed: boolean;
  isErknmStatusTypeCanceled: boolean;
  isErpStatusTypeWaitingCarryOut: boolean;
  isErpStatusTypeCarriedOut: boolean;
  isKnmEditEnabledByEditors: boolean;
  isErpStatusSyspApprove: boolean;
  isErpStatusNeedDoOverAgain: boolean;
  isChangePlanReasonActive: boolean;
  isErpStatusDeleted: boolean;
  isErpStatusClosedErknm: boolean;
  isErpStatusNew: boolean;
  actionsDropdownVisible: boolean;
  location: 'header' | 'form';
  isHeaderSticked: boolean;
  openRemoveFromPlanModal: (() => void) | undefined;
  openChangeKnmModal: (() => void) | undefined;
  downloadProsecutorDocs: (() => void) | undefined;
  knmKindDictionaryValue: IDictionaryValue<IKnmKind> | undefined;
  handleDeleteKnm: () => void;
  isKnmCanBeSigned: boolean | undefined;
  isShowErknmToApproveButton: boolean | undefined;
  onToApproveButtonClick: () => void;
  userKnoOrganisations: IUserOrganisation[];
  knoOrganizationErknm: IDictionaryKnoOrganizationSelectOption | undefined;
  enabledByTestUser: boolean;
  isUserTest: boolean;
  onClickButtonSign: () => void;
  resigningRequired: boolean;
  created: string | null | undefined;
  settings: IAdminSetting[] | undefined;
  pmTypesSelectOptions: IDictionarySelectOption<IProfKind>[] | undefined;
  isErknmStatusRemark: boolean;
  isErknmStatusAppealed: boolean;
  formRef: IKnmFormRef | undefined;
  knmFormAgreementsValue: IErknmFormAgreement[] | undefined;
  knmIsTypeErknmPlanned: boolean;
  pmStatusHasHintFields?: boolean;
  changePlanReasonApproveType: ApprovedTypesEnum | undefined;
  pmTypeFormValue: IDictionaryProfKindSelectOption | undefined;
}

const KnmHeaderDropdownWithoutStore = ({
  handleDeleteKnm,
  isOmbudsman,
  knmData,
  isAdmin,
  isProsecutorOrSuperProsecutor,
  isSupervisor,
  knmSystemType,
  knmPlanStatus,
  isErknmStatusFillInProcess,
  isErknmStatusTypeCarriedOut,
  isErknmStatusTypeWaitingCarryOut,
  isErknmStatusTypeCantBeCarryOut,
  isErknmStatusApproving,
  isErknmStatusReadyForApprove,
  isErknmStatusNotApprove,
  isErknmStatusDecisionAppealed,
  isErknmStatusTypeCanceled,
  isErpStatusTypeWaitingCarryOut,
  isErpStatusTypeCarriedOut,
  isErpStatusSyspApprove,
  isErpStatusNeedDoOverAgain,
  isKnmEditEnabledByEditors,
  isChangePlanReasonActive,
  isErpStatusDeleted,
  isErpStatusClosedErknm,
  isErpStatusNew,
  actionsDropdownVisible,
  location,
  isHeaderSticked,
  openRemoveFromPlanModal,
  openChangeKnmModal,
  downloadProsecutorDocs,
  knmKindDictionaryValue,
  isKnmCanBeSigned,
  isShowErknmToApproveButton,
  onToApproveButtonClick,
  userKnoOrganisations,
  knoOrganizationErknm,
  enabledByTestUser,
  isUserTest,
  onClickButtonSign,
  resigningRequired,
  created,
  settings,
  pmTypesSelectOptions,
  isErknmStatusRemark,
  isErknmStatusAppealed,
  formRef,
  knmFormAgreementsValue,
  knmIsTypeErknmPlanned,
  pmStatusHasHintFields,
  changePlanReasonApproveType,
  pmTypeFormValue,
}: IKnmHeaderDropdownProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();
  const history = useHistory();

  const [isActive, setIsActive] = useState(defineIsActive(location, isHeaderSticked));

  useEffect(() => {
    setIsActive(defineIsActive(location, isHeaderSticked));
  }, [location, isHeaderSticked]);

  const problemsRoute = useCallback(() => {
    dispatch(feedbackReset());
    history.push(ROUTE_FEEDBACK);

    if (knmData) {
      const knmFeedbackData: IFeedbackKnmData = {
        id: knmData.id,
        erpId: knmData.erpId,
        status: knmData.status?.name,
        signed: knmData.signed,
        type: knmData.type?.name,
        kindKnm: knmKindDictionaryValue?.value.title,
        approveRequired: knmData.knmErknm?.approve?.approveRequired,
      };

      dispatch(feedbackSetKnmData(knmFeedbackData));
    }
  }, [dispatch, knmData, history, knmKindDictionaryValue]);

  const isErp = knmSystemType === KnmSystemTypesEnum.ERP;
  const isErknm = knmSystemType === KnmSystemTypesEnum.ERKNM;
  const isPm = knmSystemType === KnmSystemTypesEnum.PM;
  const isTypeCodePP248P294 = knmData?.type?.code === KnmTypeCodesEnum.PP248P294;
  const isKnmPlanErknmStatusInProcess: boolean = getIsPlanErknmStatusInProcess(knmPlanStatus);
  const isKnmPlanErknmStatusUnderConsideration: boolean = getIsPlanErknmStatusUnderConsideration(knmPlanStatus);
  const isKnmPlanErknmStatusApproved: boolean = getIsPlanErknmStatusApproved(knmPlanStatus);
  const isKnmPlanErknmStatusConsidered: boolean = getIsPlanErknmStatusConsidered(knmPlanStatus);
  const isInPlan: boolean = Boolean(knmData?.planId);
  const isPlanOutButtonEnabled = isErknm
    ? (isProsecutorOrSuperProsecutor && isErknmStatusApproving && isKnmPlanErknmStatusUnderConsideration) ||
      (isSupervisor && isErknmStatusTypeWaitingCarryOut && isKnmPlanErknmStatusApproved)
    : isInPlan && (isErpStatusTypeWaitingCarryOut || isErpStatusTypeCarriedOut);
  const enableDownloadDocsButton =
    knmData?.knmErknm?.reasonDocuments?.some(el => el.attachments?.length) || knmData?.knmErknm?.attachmentsWeb?.length;
  const isTypeCodePP = knmData?.type?.code === KnmTypeCodesEnum.PP;
  const isTypeCodeVP = knmData?.type?.code === KnmTypeCodesEnum.VP;
  const isApproveRequired = knmData?.knmErknm?.approve?.approveRequired === ApproveRequiredTypesEnum.REQUIRED;
  const isFilledApproved = !!knmData?.knmErknm?.approve?.approved;
  const hasPlanNumber = !!knmData?.planId;
  // TODO: Временно разрешено редактирование проверок созданных через СМЭВ
  // const isCreatedByERPDB = knmData?.createdBy.username === ERPDB_USERNAME;
  const isCreatedByERPDB = false;

  const statusCode = knmData?.status?.code;

  const isStatusValidationOP =
    pmTypeFormValue?.code === ProfKindCodesEnum.OP &&
    (statusCode === KnmErknmStatusCodesEnum.TYPE_CANT_BE_CARRY_OUT ||
      statusCode === KnmErknmStatusCodesEnum.TYPE_CANCELED);

  const isStatusValidationPP =
    pmTypeFormValue?.code === ProfKindCodesEnum.PP &&
    (statusCode === KnmErknmStatusCodesEnum.TYPE_WAITING_CARRY_OUT ||
      statusCode === KnmErknmStatusCodesEnum.DECISION_APPEALED ||
      statusCode === KnmErknmStatusCodesEnum.TYPE_CANT_BE_CARRY_OUT ||
      statusCode === KnmErknmStatusCodesEnum.TYPE_CANCELED);

  const canCopyPm = isPm && (isStatusValidationOP || isStatusValidationPP);

  const isErknmCopyButtonEnabled =
    canCopyPm ||
    (isSupervisor &&
      isTypeCodeVP &&
      isApproveRequired &&
      isFilledApproved &&
      userKnoOrganisations.some(
        item => item.id === knoOrganizationErknm?.id?.toString() || item.id === knoOrganizationErknm?.idStr?.toString(),
      ) &&
      (isErknmStatusTypeWaitingCarryOut ||
        isErknmStatusTypeCarriedOut ||
        isErknmStatusNotApprove ||
        isErknmStatusDecisionAppealed ||
        isErknmStatusTypeCanceled ||
        isErknmStatusTypeCantBeCarryOut));

  const handleOpenCopyModal = () => dispatch(knmAddVisibleModal(KnmModalsEnum.COPY_KNM_MODAL));
  const handleOpenChangeStatusToRevisionModal = () =>
    dispatch(knmAddVisibleModal(KnmModalsEnum.CHANGE_STATUS_MODAL_TO_REVISION));
  const handleDownloadXml = () => dispatch(knmDownloadXml());
  const handleOpenSignUploadModal = () => dispatch(knmAddVisibleModal(KnmModalsEnum.SIGN_UPLOAD_MODAL));
  const handleDeleteSign = () => dispatch(knmDeleteSign());
  const handleDownloadSignedZip = () => dispatch(knmDownloadSignedZip());
  const handleRestoreKnm = () => dispatch(knmRestore());

  const handleExportClick = (format: ExportFormatsEnum) => () => dispatch(knmExportKnm(format));
  const handleExportPlan = (format: ExportFormatsEnum, id?: number | string | null, approved = false) => () => {
    if (typeof id === 'number' || typeof id === 'string') {
      dispatch(planListExportPlanById(format, Number(id), approved));
    }
  };

  const handleExportSimilaritiesKnmList = (format: ExportFormatsEnum, type: ExportSimilaritiesListTypesEnum) => () =>
    dispatch(knmExportSimilaritiesList(format, type));

  const excludeKnmFromPlan = (params?: IKnmMoveToPlanAttachment | IKnmExclusionReasonSelectOption) =>
    dispatch(knmExcludeFromPlan(params));

  function handleDropdownExcludeButtonClick() {
    dispatch(knmSetActionsDropdownVisible(false));
    if (isProsecutorOrSuperProsecutor) {
      excludeKnmFromPlan();
    }
    if (isSupervisor) {
      makeDropdownItemClickHandler(openRemoveFromPlanModal)();
    }
  }

  const makeDropdownItemClickHandler = (onClick: (() => void) | undefined) => () => {
    dispatch(knmSetActionsDropdownVisible(false));
    onClick?.();
  };
  const downloadCurrentVersion = () => dispatch(knmDownloadCurrentVersion());

  const restoreToLatestSigned = () => dispatch(knmRestoreToLatestVersion());

  function handleDropdownVisibleChange(visible: boolean) {
    if (isActive) {
      dispatch(knmSetActionsDropdownVisible(visible));
    }
  }

  const handleOpenAccessSettingsModal = () => dispatch(knmAddVisibleModal(KnmModalsEnum.ACCESS_SETTINGS));

  const handleOpenErknmCopyModal = () => dispatch(knmAddVisibleModal(KnmModalsEnum.ERKNM_COPY_MODAL));

  const handleOpenCancelPrescribeModal = () => dispatch(knmAddVisibleModal(KnmModalsEnum.ERKNM_PRESCRIBE_CANCEL));

  const handleOpenCancelActModal = () => dispatch(knmAddVisibleModal(KnmModalsEnum.ERKNM_ACT_CANCEL));

  const handleOpenCancelWarningModal = () => dispatch(knmAddVisibleModal(KnmModalsEnum.PM_OP_CANCEL_WARNING_PASSPORT));

  const copyItems: IDropdownItem[] = [
    {
      id: 'copy',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleOpenCopyModal)}
          isDisabled={isProsecutorOrSuperProsecutor}
        >
          Копировать
        </DropdownItem>
      ),
    },
  ];
  const exportKnmInPdfItem: IDropdownItem = {
    id: 'export-pdf',
    content: (
      <DropdownItem
        onClick={makeDropdownItemClickHandler(handleExportClick(ExportFormatsEnum.PDF))}
        isDisabled={isTypeCodePP248P294}
      >
        Экспорт в PDF
      </DropdownItem>
    ),
  };
  const exportKnmRestItems: IDropdownItem[] = [
    {
      id: 'export-ods',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleExportClick(ExportFormatsEnum.ODS))}
          isDisabled={isTypeCodePP248P294}
        >
          Экспорт в ODS
        </DropdownItem>
      ),
    },
    {
      id: 'export-xlsx',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleExportClick(ExportFormatsEnum.XLSX))}
          isDisabled={isTypeCodePP248P294}
        >
          Экспорт в XLSX
        </DropdownItem>
      ),
    },
  ];
  const exportPlanItems: IDropdownItem[] = [
    {
      id: 'export-ods-plan',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleExportPlan(ExportFormatsEnum.ODS, knmData?.planId))}
          isDisabled={!knmData?.planId}
        >
          Экспорт полного плана в ODS
        </DropdownItem>
      ),
    },
    {
      id: 'export-xlsx-plan',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleExportPlan(ExportFormatsEnum.XLSX, knmData?.planId))}
          isDisabled={!knmData?.planId}
        >
          Экспорт полного плана в XLSX
        </DropdownItem>
      ),
    },
    {
      id: 'export-approved-ods-plan',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleExportPlan(ExportFormatsEnum.ODS, knmData?.planId, true))}
          isDisabled={!(isKnmPlanErknmStatusConsidered || isKnmPlanErknmStatusApproved)}
        >
          Экспорт утверждённого плана в ODS
        </DropdownItem>
      ),
    },
    {
      id: 'export-approved-xlsx-plan',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleExportPlan(ExportFormatsEnum.XLSX, knmData?.planId, true))}
          isDisabled={!(isKnmPlanErknmStatusConsidered || isKnmPlanErknmStatusApproved)}
        >
          Экспорт утверждённого плана в XLSX
        </DropdownItem>
      ),
    },
  ];
  const toRevisionItems: IDropdownItem[] = [
    {
      id: 'divider-to-revision',
      isDivider: true,
    },
    {
      id: 'to-revision',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleOpenChangeStatusToRevisionModal)}
          isDisabled={isCreatedByERPDB}
        >
          На доработку
        </DropdownItem>
      ),
    },
  ];
  const toApproveItems: IDropdownItem[] = [
    {
      id: 'divider-to-approve',
      isDivider: true,
    },
    {
      id: 'to-approve',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(onToApproveButtonClick)}
          isDisabled={isCreatedByERPDB || !isKnmEditEnabledByEditors}
        >
          Отправить на согласование
        </DropdownItem>
      ),
    },
  ];
  const exportOutputItems: IDropdownItem[] = [
    {
      id: 'divider-similarity',
      isDivider: true,
    },
    {
      id: 'output-ods',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(
            handleExportSimilaritiesKnmList(ExportFormatsEnum.ODS, ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_KNM),
          )}
          isDisabled
        >
          Вывести совпадения в ODS
        </DropdownItem>
      ),
    },
    {
      id: 'output-xlsx',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(
            handleExportSimilaritiesKnmList(ExportFormatsEnum.XLSX, ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_KNM),
          )}
          isDisabled
        >
          Вывести совпадения в XLSX
        </DropdownItem>
      ),
    },
    {
      id: 'output-allrf-ods',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(
            handleExportSimilaritiesKnmList(
              ExportFormatsEnum.ODS,
              ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_PLAN_ALL,
            ),
          )}
          isDisabled={!isInPlan}
        >
          Вывести совпадения по плану (По всей РФ) в ODS
        </DropdownItem>
      ),
    },
    {
      id: 'output-allrf-xlsx',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(
            handleExportSimilaritiesKnmList(
              ExportFormatsEnum.XLSX,
              ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_PLAN_ALL,
            ),
          )}
          isDisabled={!isInPlan}
        >
          Вывести совпадения по плану (По всей РФ) в XLSX
        </DropdownItem>
      ),
    },
    {
      id: 'output-subject-ods',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(
            handleExportSimilaritiesKnmList(ExportFormatsEnum.ODS, ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_PLAN),
          )}
          isDisabled={!isInPlan}
        >
          Вывести совпадения по плану (По субъекту РФ) в ODS
        </DropdownItem>
      ),
    },
    {
      id: 'output-subject-xlsx',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(
            handleExportSimilaritiesKnmList(ExportFormatsEnum.XLSX, ExportSimilaritiesListTypesEnum.KNM_MATCH_BY_PLAN),
          )}
          isDisabled={!isInPlan}
        >
          Вывести совпадения по плану (По субъекту РФ) в XLSX
        </DropdownItem>
      ),
    },
  ];

  const erknmOrganizationActs = useMemo(() => knmData?.knmErknm?.organizations?.map((i: IKnmSubject248) => i.act), [
    knmData?.knmErknm?.organizations,
  ]);
  const isPmUnableToRefuse = knmData?.pmErknm?.isUnableToRefuse;
  const pmSubjectAct = knmData?.pmErknm?.subject?.act;

  /**
   * Есть ли неподписанный безбумажный акт.
   * Аналогично проверке в KnmHeaderButtons, которая скрывает кнопку "Подписать паспорт".
   */
  const hasUnsignedAct = useMemo(() => {
    return (
      !!erknmOrganizationActs?.find((act: IKnmAct248) => act && !act.signed && act.paperless) ||
      (!!isPmUnableToRefuse && (pmSubjectAct ? !pmSubjectAct.signed && pmSubjectAct.paperless : false))
    );
  }, [erknmOrganizationActs, isPmUnableToRefuse, pmSubjectAct]);

  const resultDecisions = formRef?.current.getFieldState('resultDecisions')?.value;
  const pmResultDecisions = formRef?.current.getFieldState('pmResultDecisions')?.value;

  /**
   * Есть ли неподписанное предписание (D_1/D_7, безбумажное).
   * Аналогично проверке в KnmHeaderButtons, которая скрывает кнопку "Подписать паспорт"
   */
  const hasUnsignedResultDecision = useMemo(() => {
    return (
      !!resultDecisions?.find(
        rd =>
          (rd.kindDecision?.code === KindResultDecisionCodesEnum.D_1 ||
            rd.kindDecision?.code === KindResultDecisionCodesEnum.D_7) &&
          rd.paperless &&
          !rd.signed,
      ) ||
      !!pmResultDecisions?.find(
        rd =>
          (rd.kindDecision?.code === KindResultDecisionCodesEnum.D_1 ||
            rd.kindDecision?.code === KindResultDecisionCodesEnum.D_7) &&
          rd.paperless &&
          !rd.signed,
      )
    );
  }, [JSON.stringify(resultDecisions), JSON.stringify(pmResultDecisions)]);

  const isSignDisabled = !(isKnmCanBeSigned && isKnmEditEnabledByEditors);
  const unsignedActionsItems: IDropdownItem[] = [
    {
      id: 'download-xml',
      content: (
        <DropdownItem onClick={makeDropdownItemClickHandler(handleDownloadXml)} isDisabled={isTypeCodePP248P294}>
          Экспорт в XML
        </DropdownItem>
      ),
    },
  ];

  const isSupervisorAndErknmStatusForSign =
    isSupervisor && (isErknmStatusReadyForApprove || isErknmStatusFillInProcess);

  const isDeleteSignDisabled =
    isTypeCodePP248P294 ||
    !isKnmEditEnabledByEditors ||
    isProsecutorOrSuperProsecutor ||
    !isSupervisorAndErknmStatusForSign;
  const signedActionsItems: IDropdownItem[] = [
    {
      id: 'divider-with-signature',
      isDivider: true,
    },
  ];

  const isDeniedChangePlanReasonForProsecutor =
    isProsecutorOrSuperProsecutor &&
    knmIsTypeErknmPlanned &&
    isErknmStatusTypeWaitingCarryOut &&
    changePlanReasonApproveType === ApprovedTypesEnum.DENIED;

  if (!isErpStatusClosedErknm && !isProsecutorOrSuperProsecutor) {
    unsignedActionsItems.unshift({
      id: 'sign',
      content: (
        <DropdownItem
          id="signButton"
          onClick={makeDropdownItemClickHandler(onClickButtonSign)}
          isDisabled={
            isSignDisabled ||
            hasUnsignedResultDecision ||
            hasUnsignedAct ||
            (isPm && pmStatusHasHintFields) ||
            (isErknm && isDeniedChangePlanReasonForProsecutor)
          }
        >
          Подписать
        </DropdownItem>
      ),
    });
    if (!isUserTest) {
      unsignedActionsItems.push({
        id: 'upload-xml-signed',
        content: (
          <DropdownItem onClick={makeDropdownItemClickHandler(handleOpenSignUploadModal)} isDisabled={isSignDisabled}>
            Загрузить подпись
          </DropdownItem>
        ),
      });
    }

    if (enabledByTestUser) {
      signedActionsItems.push({
        id: 'delete-sign',
        content: (
          <DropdownItem onClick={makeDropdownItemClickHandler(handleDeleteSign)} isDisabled={isDeleteSignDisabled}>
            Удалить подпись
          </DropdownItem>
        ),
      });
    }
  }
  signedActionsItems.push({
    id: 'download-xml-signed',
    content: (
      <DropdownItem onClick={makeDropdownItemClickHandler(handleDownloadSignedZip)} isDisabled={isTypeCodePP248P294}>
        Экспорт в XML с подписями
      </DropdownItem>
    ),
  });

  const signedExportActionItems: IDropdownItem[] = [
    {
      id: 'download-signed-xml-version',
      content: (
        <DropdownItem onClick={makeDropdownItemClickHandler(downloadCurrentVersion)} isDisabled={isTypeCodePP248P294}>
          Экспорт подписанного КНМ
        </DropdownItem>
      ),
    },
  ];

  const backupSignedActionItems: IDropdownItem[] = [
    {
      id: 'get-backup-signed-version',
      content: (
        <DropdownItem onClick={makeDropdownItemClickHandler(restoreToLatestSigned)}>
          Восстановить последний подписанный паспорт
        </DropdownItem>
      ),
    },
  ];

  const restoreItems: IDropdownItem[] = [
    {
      id: 'divider-restore',
      isDivider: true,
    },
    {
      id: 'restore',
      content: (
        <DropdownItem onClick={makeDropdownItemClickHandler(handleRestoreKnm)} isSuccess>
          Восстановить
        </DropdownItem>
      ),
    },
  ];
  const deleteItems: IDropdownItem[] = [
    {
      id: 'divider-delete',
      isDivider: true,
    },
    {
      id: 'delete',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleDeleteKnm)}
          isDanger
          isDisabled={!isKnmEditEnabledByEditors}
        >
          Удалить
        </DropdownItem>
      ),
    },
  ];
  const planOutItems: IDropdownItem[] = [
    {
      id: 'plan-out',
      content: (
        <DropdownItem onClick={handleDropdownExcludeButtonClick} isDisabled={!isPlanOutButtonEnabled}>
          Исключить из плана
        </DropdownItem>
      ),
    },
  ];
  const toChangeItems: IDropdownItem[] = [
    {
      id: 'divider-to-change',
      isDivider: true,
    },
    {
      id: 'to-change',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(openChangeKnmModal)}
          isDisabled={isProsecutorOrSuperProsecutor || isChangePlanReasonActive}
        >
          Внести изменения в КНМ
        </DropdownItem>
      ),
    },
  ];
  const prosecutorDocs: IDropdownItem[] = [
    {
      id: 'prosecutor-docs',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(downloadProsecutorDocs)}
          isDisabled={!enableDownloadDocsButton}
        >
          Комплект документов для прокуратуры
        </DropdownItem>
      ),
    },
  ];
  const accessSettings: IDropdownItem[] = [
    {
      id: 'divider-access-settings',
      isDivider: true,
    },
    {
      id: 'access-settings',
      content: (
        <DropdownItem
          onClick={makeDropdownItemClickHandler(handleOpenAccessSettingsModal)}
          isDisabled={!isKnmEditEnabledByEditors}
        >
          Настроить права доступа
        </DropdownItem>
      ),
    },
  ];

  const knmProblem: IDropdownItem[] = [
    {
      id: 'knmProblem',
      content: <DropdownItem onClick={problemsRoute}>Проблема с КНМ</DropdownItem>,
    },
  ];

  const erknmCopy: IDropdownItem = {
    id: 'erknmCopy',
    content: (
      <DropdownItem isDisabled={!isErknmCopyButtonEnabled} onClick={handleOpenErknmCopyModal}>
        {isPm && 'Создать копию ПМ'}
        {!isPm && 'Создать копию КНМ'}
      </DropdownItem>
    ),
  };

  const cancelPrescribe: IDropdownItem = {
    id: 'cancelPrescribe',
    content: <DropdownItem onClick={handleOpenCancelPrescribeModal}>Отменить предписание</DropdownItem>,
  };

  const cancelAct: IDropdownItem = {
    id: 'cancelAct',
    content: <DropdownItem onClick={handleOpenCancelActModal}>Отменить результаты</DropdownItem>,
  };

  const cancelWarning: IDropdownItem = {
    id: 'cancelWarning',
    content: <DropdownItem onClick={handleOpenCancelWarningModal}>Отменить предостережение</DropdownItem>,
  };

  const isEnablePaperlessDocument = isLaterThanAdminSetting(
    created,
    settings,
    AdminSettingCodesEnum.ENABLED_PAPERLESS_PASSPORT_4_1_3_STARTS_FROM,
  );

  const agreements =
    (formRef?.current.getFieldState('agreements' as keyof IKnmForm)?.value as IErknmFormAgreement[]) ||
    knmFormAgreementsValue;

  const canCancelPrescribe = useMemo(() => {
    const prescribes: (IKnmResultDecision248 | IPmResultDecision)[] = [];

    knmData?.knmErknm?.organizations?.forEach(org => {
      if (org.resultDecisions) {
        org.resultDecisions.forEach(decision => {
          if (
            (decision.kindDecision?.code === KindResultDecisionCodesEnum.D_1 ||
              decision.kindDecision?.code === KindResultDecisionCodesEnum.D_7) &&
            (decision.status === KnmResultDecisionStatusEnum.COMPLETED ||
              decision.status === KnmResultDecisionStatusEnum.NOT_COMPLETED) &&
            decision.signed
          ) {
            const bindedAgreement = agreements?.find(
              agreement =>
                agreement.prescription?.value === decision.guid &&
                (agreement.status === AgreementStatusEnum.DRAFT ||
                  agreement.status === AgreementStatusEnum.READY_TO_APPROVE ||
                  agreement.status === AgreementStatusEnum.ON_APPROVAL ||
                  agreement.status === AgreementStatusEnum.APPROVED ||
                  agreement.status === AgreementStatusEnum.PENDING_TERMINATION ||
                  agreement.status === AgreementStatusEnum.COMPLETED),
            );

            if (
              !bindedAgreement ||
              decision.agreementStatus === KnmResultDecisionAgreementStatusEnum.AGREEMENT_COMPLETED
            ) {
              prescribes.push(decision);
            }
          }
        });
      }
    });

    if (knmData?.pmErknm?.subject?.pmResultDecisions) {
      knmData?.pmErknm?.subject?.pmResultDecisions.forEach(decision => {
        if (
          (decision.kindDecision?.code === KindResultDecisionCodesEnum.D_1 ||
            decision.kindDecision?.code === KindResultDecisionCodesEnum.D_7) &&
          (decision.status === KnmResultDecisionStatusEnum.COMPLETED ||
            decision.status === KnmResultDecisionStatusEnum.NOT_COMPLETED) &&
          decision.signed
        ) {
          const bindedAgreement = agreements?.find(
            agreement =>
              agreement.prescription?.value === decision.guid &&
              (agreement.status === AgreementStatusEnum.DRAFT ||
                agreement.status === AgreementStatusEnum.READY_TO_APPROVE ||
                agreement.status === AgreementStatusEnum.ON_APPROVAL ||
                agreement.status === AgreementStatusEnum.APPROVED ||
                agreement.status === AgreementStatusEnum.PENDING_TERMINATION ||
                agreement.status === AgreementStatusEnum.COMPLETED),
          );

          if (!bindedAgreement) {
            prescribes.push(decision);
          }
        }
      });
    }

    return isEnablePaperlessDocument && prescribes.length > 0;
  }, [isEnablePaperlessDocument, knmData, formRef, agreements]);

  const canCancelAct = useMemo(() => {
    const acts: IKnmAct248[] = [];

    knmData?.knmErknm?.organizations?.forEach(org => {
      if (org.act?.signed && !org.act.fileInvalidate) {
        const prescribe = org.resultDecisions?.find(p => p.actGuid === org.act?.guid);

        const bindedAgreement = agreements?.find(
          agreement =>
            agreement.prescription?.value === prescribe?.guid &&
            (agreement.status === AgreementStatusEnum.DRAFT ||
              agreement.status === AgreementStatusEnum.READY_TO_APPROVE ||
              agreement.status === AgreementStatusEnum.ON_APPROVAL ||
              agreement.status === AgreementStatusEnum.APPROVED ||
              agreement.status === AgreementStatusEnum.PENDING_TERMINATION ||
              agreement.status === AgreementStatusEnum.COMPLETED),
        );

        if (!bindedAgreement) {
          acts.push(org.act);
        }
      }
    });

    if (knmData?.pmErknm?.subject?.act?.signed && !knmData?.pmErknm?.subject?.act.fileInvalidate) {
      const prescribe = knmData?.pmErknm?.subject.resultDecisions?.find(
        p => p.actGuid === knmData?.pmErknm?.subject?.act?.guid,
      );

      const bindedAgreement = agreements?.find(
        agreement =>
          agreement.prescription?.value === prescribe?.guid &&
          (agreement.status === AgreementStatusEnum.DRAFT ||
            agreement.status === AgreementStatusEnum.READY_TO_APPROVE ||
            agreement.status === AgreementStatusEnum.ON_APPROVAL ||
            agreement.status === AgreementStatusEnum.APPROVED ||
            agreement.status === AgreementStatusEnum.PENDING_TERMINATION ||
            agreement.status === AgreementStatusEnum.COMPLETED),
      );

      if (!bindedAgreement) {
        acts.push(knmData?.pmErknm?.subject?.act);
      }
    }

    return isEnablePaperlessDocument && acts.length > 0;
  }, [isEnablePaperlessDocument, knmData, agreements]);

  const canCancelWarning = useMemo(() => {
    if (!isPm) return false;

    // eslint-disable-next-line @typescript-eslint/no-shadow
    const pmType = pmTypesSelectOptions?.find(
      i =>
        i.value.dictId === knmData?.pmErknm?.pmType?.dictId &&
        i.value.dictVersionId === knmData?.pmErknm?.pmType?.dictVersionId,
    );

    return (
      isEnablePaperlessDocument &&
      pmType?.code === ProfKindCodesEnum.OP &&
      (isErknmStatusRemark || isErknmStatusAppealed || (isErknmStatusTypeCanceled && resigningRequired))
    );
  }, [isEnablePaperlessDocument, pmTypesSelectOptions, knmData]);

  const dropdownItems = () => {
    let res: IDropdownItem[] = [];

    if (!knmData?.id) {
      return res;
    }
    if (!isOmbudsman) {
      if ((isAdmin || isProsecutorOrSuperProsecutor || isSupervisor) && !isErknm && !isPm) {
        res = [...copyItems];
      }
      res = [...res, exportKnmInPdfItem];
      if (!isOmbudsman && !isPm) {
        res = [...res, ...exportKnmRestItems];
      }
      if (knmData?.type?.code === KnmTypeCodesEnum.PP && !isOmbudsman) {
        res = [...res, ...exportPlanItems];
      }
      if (isSupervisor && isShowErknmToApproveButton && enabledByTestUser && !knmData.resigningRequired) {
        res = [...res, ...toApproveItems];
      }
      if (isProsecutorOrSuperProsecutor || isSupervisor) {
        if (isErp) {
          if (isErpStatusSyspApprove || isErpStatusTypeWaitingCarryOut) {
            res = [...res, ...toRevisionItems];
          } else if (isErpStatusNeedDoOverAgain && !knmData.resigningRequired) {
            res = [...res, ...toApproveItems];
          }
        }
        if (
          isErknm &&
          knmData.type?.code === KnmTypeCodesEnum.PP &&
          isErknmStatusTypeWaitingCarryOut &&
          isKnmPlanErknmStatusApproved &&
          enabledByTestUser
        ) {
          res = [...res, ...toChangeItems];
        }
      }
      if (knmData?.type?.code === KnmTypeCodesEnum.PP && !isOmbudsman) {
        res = [...res, ...exportOutputItems];
      }
      if (isProsecutorOrSuperProsecutor || isSupervisor) {
        if (knmData.signed && !knmData.resigningRequired) {
          if (!knmData.deleted) {
            res = [...res, ...signedActionsItems.filter(item => (res.length === 0 ? !item.isDivider : true))];
          }
          if (!isErp) {
            res = [...res, ...signedExportActionItems];
          }
        } else if (!knmData.deleted && enabledByTestUser) {
          res = [...res, ...unsignedActionsItems];
        }
      }
      if (isSupervisor && !isErp && resigningRequired) {
        res = [...res, ...backupSignedActionItems];
      }
      if (((isProsecutorOrSuperProsecutor && isErknm) || (isSupervisor && isErknm)) && enabledByTestUser) {
        res = [...res, ...prosecutorDocs];
      }
      if ((isPm || (isErknm && (isTypeCodePP || isTypeCodeVP))) && enabledByTestUser) {
        res = [...res, ...accessSettings];
      }
      if (knmData?.deleted && isErpStatusDeleted && !isCreatedByERPDB && enabledByTestUser) {
        res = [...res, ...restoreItems];
      }
      if (
        !knmData?.deleted &&
        !isCreatedByERPDB &&
        knmData.status?.code !== KnmErpStatusCodesEnum.TYPE_COMPLETED &&
        enabledByTestUser
      ) {
        if (
          (isErp &&
            (isErpStatusNew ||
              isProsecutorOrSuperProsecutor ||
              (isSupervisor && knmData?.type?.code === KnmTypeCodesEnum.VP))) ||
          (isErknm &&
            isSupervisor &&
            (isErknmStatusFillInProcess || isErknmStatusReadyForApprove) &&
            (!isTypeCodePP ||
              !hasPlanNumber ||
              (isTypeCodePP && (!knmData.planId || isKnmPlanErknmStatusApproved || isKnmPlanErknmStatusInProcess)))) ||
          (isPm && isSupervisor && isErknmStatusFillInProcess)
        ) {
          res = [...res, ...deleteItems];
        }
      }
      if (knmData.type?.code === KnmTypeCodesEnum.PP && isSupervisor && enabledByTestUser) {
        res = [...res, ...planOutItems];
      }
    }

    if (isErknm && enabledByTestUser) {
      res = [...res, ...knmProblem, erknmCopy];
    }

    if (isPm) {
      res = [...res, erknmCopy];
    }

    if (isErknm && enabledByTestUser && isSupervisor && canCancelPrescribe) {
      res = [...res, cancelPrescribe];
    }

    if (isErknm && enabledByTestUser && isSupervisor && canCancelAct) {
      res = [...res, cancelAct];
    }

    if (isPm && enabledByTestUser && isSupervisor && canCancelWarning) {
      res = [...res, cancelWarning];
    }

    if (isPm && enabledByTestUser && isSupervisor && canCancelAct) {
      res = [...res, cancelAct];
    }

    if (isPm && enabledByTestUser && isSupervisor && canCancelPrescribe) {
      res = [...res, cancelPrescribe];
    }

    return res;
  };

  return (
    <Dropdown
      items={dropdownItems()}
      visible={actionsDropdownVisible}
      disabled={Boolean(!knmData?.id)}
      onVisibleChange={handleDropdownVisibleChange}
      isTopMenu={true}
      hideByScroll={true}
    />
  );
};

const mapStateToProps = (state: IRootState) => ({
  isOmbudsman: getUserRoleIsOmbudsman(state),
  knmData: getKnmData(state),
  isAdmin: getUserRoleIsAdmin(state),
  isProsecutorOrSuperProsecutor: getUserRoleIsProsecutorOrSuperProsecutor(state),
  isSupervisor: getUserRoleIsSupervisor(state),
  knmSystemType: getKnmSystemType(state),
  knmPlanStatus: getPlanListPlanErknmStatus(state),
  isErknmStatusFillInProcess: getKnmIsErknmStatusFillInProcess(state),
  isErknmStatusTypeCarriedOut: getKnmIsErknmStatusTypeCarriedOut(state),
  isErknmStatusTypeWaitingCarryOut: getKnmIsErknmStatusTypeWaitingCarryOut(state),
  isErknmStatusTypeCantBeCarryOut: getKnmIsErknmStatusTypeCantBeCarryOut(state),
  isErknmStatusApproving: getKnmIsErknmStatusApproving(state),
  isErknmStatusReadyForApprove: getKnmIsErknmStatusReadyForApprove(state),
  isErknmStatusNotApprove: getKnmIsErknmStatusNotApprove(state),
  isErknmStatusDecisionAppealed: getKnmIsErknmStatusDecisionAppealed(state),
  isErknmStatusTypeCanceled: getKnmIsErknmStatusTypeCanceled(state),
  isErpStatusTypeWaitingCarryOut: getKnmIsErpStatusTypeWaitingCarryOut(state),
  isErpStatusTypeCarriedOut: getKnmIsErpStatusTypeCarriedOut(state),
  isErpStatusSyspApprove: getKnmIsErpStatusSyspApprove(state),
  isErpStatusNeedDoOverAgain: getKnmIsErpStatusNeedDoOverAgain(state),
  isChangePlanReasonActive: !!getKnmIsChangePlanReasonActive(state),
  isErpStatusDeleted: getKnmIsErpStatusDeleted(state),
  isErpStatusClosedErknm: getKnmIsErpStatusClosedErknm(state),
  isErpStatusNew: getKnmIsErpStatusNew(state),
  actionsDropdownVisible: getKnmActionsDropdownVisible(state),
  isHeaderSticked: getIsSticked(state),
  isKnmEditEnabledByEditors: getKnmIsEditEnabledByEditors(state),
  openChangeKnmModal: getKnmOpenChangeKnmModal(state),
  openRemoveFromPlanModal: getKnmOpenRemoveFromPlanModal(state),
  downloadProsecutorDocs: getKnmDownloadProsecutorDocs(state),
  knmKindDictionaryValue: getKnmErknmKnmKindDictionaryValue(state),
  isKnmCanBeSigned: getIsKnmCanBeSigned(state),
  userKnoOrganisations: getAccountOrganizationsWithDistrictData(state).kno,
  knoOrganizationErknm: getKnmErknmKnoOrganizationFormValue(state),
  isUserTest: getUserProfileIsTest(state),
  resigningRequired: getKnmDataResigningRequired(state),
  settings: getAdminFetchSettings(state),
  created: getKnmDataCreated(state),
  formRef: getKnmFormRef(state),
  pmTypesSelectOptions: getKnmErknmProfKindsSelectOptions(state),
  isErknmStatusRemark: getKnmIsErknmStatusRemark(state),
  isErknmStatusAppealed: getKnmIsErknmStatusAppealed(state),
  knmFormAgreementsValue: getKnmFormAgreementsValue(state),
  knmIsTypeErknmPlanned: getKnmIsTypeErknmPlanned(state),
  pmStatusHasHintFields: getKnmPmStatusHasHintFields(state),
  changePlanReasonApproveType: getLatestKnmErknmChangePlanReasonApproveType(state),
  pmTypeFormValue: getKnmPmTypeFormValue(state),
});

export const KnmHeaderDropdown = connect(mapStateToProps)(KnmHeaderDropdownWithoutStore);
